import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Image from "next/image";
import { configuration } from "../../helpers/config";
import { formatCurrency, IsValidPrice } from "../../utils/GenUtils";
import axios from "axios";
import Select, { components } from "react-select";
import useIsMobile from "../../hooks/useIsMobile";
import useOutsideClick from "../../hooks/useOutsideClick";
import { Modal } from "react-responsive-modal";
import { Tooltip } from "react-tooltip";

const CompareItem = ({
  data,
  id,
  onVariantChange,
  modelCode,
  fixed,
  menuId,
  propulsion,
  modelName,
  item,
  onRemoveClick,
  modelHeading,
  modelStaticPrice,
  local,
  variantCmpfirstPrice,
  variantCmpsecondPrice,
  variantCmpthirdPrice,
  variantCmpfirstPriceText,
  variantCmpsecondPriceText,
  variantCmpthirdPriceText,
  additionalInformationVariant,
  additionalInformationOfModel,
}) => {
  const [selected, setSelected] = useState(() => item || {});  // Initialize with item or empty object
  const [selectedColor, setSelectedColor] = useState(() => item?.colors ? item.colors[0] : null);
    const [groupName, setGroupName] = useState(() => item?.propulsion || "");
  const [modelPrice, setModelPrice] = useState(0);
  // const [groupName, setGroupName] = useState(item.propulsion);
  const [menuOpen, setMenuOpen] = useState(false);
  const LobValue = useSelector((state) => state?.app?.LobValue);
  const controlRef = useRef();

  const [cmpfirstPrice, setcmpfirstPrice] = useState(0);
  const [cmpsecondPrice, setcmpsecondPrice] = useState(0);
  const [cmpthirdPrice, setcmpthirdPrice] = useState(0);
  const [showPop, setShowPop] = useState(false);
  const [isPriceLoaded, setIsPriceLoaded] = useState(false);
  // function to close menu if clicked outside the area
  function handleOutsideClick() {
    setMenuOpen(false);
  }
  const initializeSelection = () => {
    setSelected(item);
    setSelectedColor(item?.colors ? item.colors[0] : null);
    setGroupName(item?.propulsion || "");
  };
  useEffect(()=>{
    initializeSelection();  // This is equivalent to your original `useEffect`
  }, [item]);
  useOutsideClick(controlRef, handleOutsideClick);
  const closeIcon = (
    <svg fill="currentColor" viewBox="0 0 20 20" width={14} height={14}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M10 8.586L1.293 0 0 1.293 8.586 10 0 18.707 1.293 20 10 11.414 18.707 20 20 18.707 11.414 10 20 1.293 18.707 0 10 8.586z"
      />
    </svg>
  );

  useEffect(() => {
    // get current date
    const currentDate = new Date().toISOString();
    //API call to get selling price of a specific variant based on color, date, dealer and LOB.
    if (!local) {
      // this will only work if data is not provided locally.
      (async () => {
        if (!LobValue) return; 
        try {
          setIsPriceLoaded(false);
          const res = await axios.get(
            // `${configuration.COMMON_MASTER_API}/sellingPrices?modelCode=${modelCode}&variantCode=${selected?.variant_code}&colorCode=${selectedColor?.color_code}&startDate=${currentDate}&endDate=${currentDate}&dealerCode=${configuration.DEALER_CODE}&lob=${configuration.COMMON_MASTER_LOB}`,
            `${configuration.COMMON_MASTER_API}/sellingPrices?modelCode=${modelCode}&variantCode=${selected?.variant_code}&colorCode=${selectedColor?.color_code}&startDate=${currentDate}&endDate=${currentDate}&dealerCode=${configuration.DEALER_CODE}&lob=${LobValue}`,

            configuration.HEADER_DEALER_LOCATOR
          );

          if (res?.data?.data[0]?.sellingPriceDetails[0]) {
            setcmpfirstPrice(
              res?.data?.data[0]?.sellingPriceDetails[0]?.[variantCmpfirstPrice]
            );
            setcmpsecondPrice(
              res?.data?.data[0]?.sellingPriceDetails[0]?.[
                variantCmpsecondPrice
              ]
            );
            setcmpthirdPrice(
              res?.data?.data[0]?.sellingPriceDetails[0]?.[variantCmpthirdPrice]
            );
            setIsPriceLoaded(true);
          }

          const sellingPrices = res?.data?.data[0]?.sellingPriceDetails?.map(
            (item) => item.price2
          );
          // get minimum selling price from all the price data fetched
          let min = Math.min(...sellingPrices);
          setModelPrice(min);
        } catch (e) {
          setModelPrice(0);
          setIsPriceLoaded(false);
        }
      })();
    } else {
      setModelPrice(selectedColor.on_road_price);
    }
  }, [selected, selectedColor, LobValue]);

  //function to handle event when user selects another variant or color
  const handleChange = (selectedOption) => {
    // set group name and close menu
    const optgroupLabel = selectedOption.group;
    setGroupName(optgroupLabel);
    setMenuOpen(false);

    //get propulsion type
    const selectedProp = propulsion.find(
      (item) => item.propulsion_name === optgroupLabel
    );

    // get variant name and code
    const selectedVariant = selectedProp.variants.find(
      (variant) => variant.variant_code === selectedOption.value
    );

    setSelected(selectedVariant);
    onVariantChange(selectedOption.value);
    setSelectedColor(selectedVariant.colors[0]);
  };

  // create options based on propulsion type
  const options = propulsion.flatMap((item) =>
    item.variants
      .sort((a, b) => a.order_index - b.order_index)
      .map((variant) => ({
        value: variant.variant_code,
        label: variant.variant_name,
        group: item.propulsion_name,
      }))
  );

  // setting up grouped options in react-select format
  const groupedOptionsPropulsion = propulsion.map((item) => ({
    label: item.propulsion_name,
    options: options.filter((option) => option.group === item.propulsion_name),
  }));

  // grouped options based on model
  const groupedOptionsModel = propulsion
    .sort((a, b) => a.order_index - b.order_index)
    .map((item) => ({
      label: modelName,
      options: options.filter(
        (option) => option.group === item.propulsion_name
      ),
    }));

  const Control = (props) => {
    const selectedOption = props.selectProps.value;
    const Co = components.Control;

    return (
      <button
        ref={controlRef}
        className="w-full  "
        onClick={() => {
          setMenuOpen(!menuOpen);
        }}
      >
        <div className="min-h-[59px] md:min-h-[84px] lg:min-h-[84px] min-h-[59px] shadow-[0px_4px_4px_rgba(0,0,0,0.15)] relative flex items-center justify-around text-center py-[12px] rounded-[4px] " id="comparisonSection">
          {/* {props.children} */}
          <div className="select-texts max-w-[86%]">
          <h2 className="md:text-[22px] text-mobileMenu mb-[4px] md:leading-[27px] md:mb-[12px]">
               {configuration.VARIANT_GROUPING_TYPE === "PROPULSION"
                 ? groupName
                 : modelName}
             </h2>
            <p className="md:text-section-heading text-[10px] leading-[16px] m-0">
              {selected?.variant_name}
            </p>
          </div>

          <div className="select-arrow">
            <img
              src={`${configuration.IMG_STATIC_URL}assets/images/${
                menuOpen ? "select-up-icon.svg" : "select-drop-icon.svg"
              }`}
              alt="select-arrow"
              className="h-[10px] w-[14px] md:h-[12px] md:w-[24px]"
            />
          </div>
        </div>
      </button>
    );
  };
  const mobile = useIsMobile();
  const Tooltip = () => {
    return (
      <>
            {/* additional information tool tip variants starts */}
            {(additionalInformationVariant ||
        additionalInformationOfModel ||
        selectedColor?.additionalInformation) &&
        (additionalInformationVariant?.enable ||
          additionalInformationOfModel?.enable ||
          selectedColor?.additionalInformation?.enable) && (
            <div className="homeSuzukiCard__priceInfo">
            <div
              className="tool-tip-img inline-flex items-center align-middle"
              data-tooltip-id={"variantInfoId" + id}
              onMouseEnter={() => setShowPop(true)}
            >
              <Image
                src={`${configuration.IMG_STATIC_URL}assets/images/infoIcon.svg`}
                height="15"
                width="15"
              />
              <p className="homeSuzukiCard__priceInfo_title">
                {selectedColor?.additionalInformation?.title
                  ? selectedColor?.additionalInformation?.title
                  : additionalInformationVariant?.title
                    ? additionalInformationVariant?.title
                    : additionalInformationOfModel?.title}
              </p>
            </div>
            <Modal
                  open={showPop}
                  closeIcon={closeIcon}
                  onClose={() => setShowPop(false)}
                  center
                  classNames={{
                    // overlay: 'customOverlay',
                  modal: "customModal",
                }}
                  // classNames={{
                  //     modal: 'shadow-lg md:max-w-[425px] max-w-[150px] rounded-[5px]'
                  // }}
              >
                  <div className="tool-tip-wrap md:max-w-[925px] max-w-[350px] md:max-h-[300px] max-h-[500px]">
                      <p className="mb-0 text-[12px] text-inverted font-suzukiRegular">
                      {selectedColor?.additionalInformation?.description
                    ? selectedColor?.additionalInformation?.description
                    : additionalInformationVariant?.description
                      ? additionalInformationVariant?.description
                      : additionalInformationOfModel?.description}
                      </p>
                  </div>
              </Modal>
            {/* <Tooltip
              id={"variantInfoId" + id}
              src={`${configuration.IMG_STATIC_URL}assets/images/Tool-tip/infoToolTip.svg`}
              variant="dark"
              place="right"
              className="shadow-lg max-w-[325px] rounded-[5px] z-[99999] "
            >
              <div className="tool-tip-wrap max-w-[325px]" >
                <p className="mb-0 text-[12px] text-inverted font-suzukiRegular">
                  {selectedColor?.additionalInformation?.description
                    ? selectedColor?.additionalInformation?.description
                    : additionalInformationVariant?.description
                      ? additionalInformationVariant?.description
                      : additionalInformationOfModel?.description}
                </p>
              </div>
            </Tooltip> */}
          </div>
        )}
      {/* additional information tool tip ends */}
      </>
    );
  };

  return (
    <div className="compareItem_imageDetails" id="compareItemImageDetails">
      <div
        className={`${
          fixed ? " compareItem__selectbox--fixed z-[2] bg-inverted" : ""
        } ${
          menuId && fixed ? "top-[100px]" : "top-[60px]"
        } compareItem__selectbox `}
      >
        <div className="compareItem-wrap relative">
          {id === 2 &&
            !(
              configuration.VARIANT_COMPARISON_SECTION_IN_WEBSITE === "true" ||
              configuration.VARIANT_COMPARISON_SECTION_IN_WEBSITE === true
            ) && (
            <button
              onClick={onRemoveClick}
              className="absolute top-[-12px] right-[-15px] z-50"
            >
              <Image
                src={`${configuration.IMG_STATIC_URL}assets/images/removeIcon.svg`}
                width={35}
                height={35}
                alt="cross"
              />
            </button>
          )}
          {!local && (
            <Select
              options={
                configuration.VARIANT_GROUPING_TYPE === "PROPULSION"
                  ? groupedOptionsPropulsion
                  : groupedOptionsModel
              }
              isSearchable={true}
              isMulti={false}
              className="bg-inverted outline-0"
              onChange={handleChange}
              menuIsOpen={menuOpen}
              openMenuOnClick={true}
              styles={{
                menu: () => ({
                  backgroundColor: "white",
                  position: "absolute",
                  zIndex: "10",
                  width: mobile ? "160%" : "100%",
                  right: id == 1 && mobile && 0,
                  top: "100%",
                  borderRadius: "4px",
                  marginTop: "8px",
                  boxShadow:
                    "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
                }),
                groupHeading: (base) => ({
                  ...base,
                  fontSize: mobile ? "15px" : "20px",
                  lineHeight: mobile ? "19px" : "24px",
                  fontFamily: "suzukiBold",
                  color: "#000000",
                }),
                option: (base, state) => ({
                  ...base,
                  fontSize: mobile ? "10px" : "16px",
                  lineHeight: mobile ? "14px" : "19px",
                  color: "black",
                  backgroundColor: state.isFocused
                    ? "#89898929"
                    : "transparent",
                  paddingLeft: "30px",
                }),
              }}
              components={{
                Control,
              }}
            />
          )}

          {local && (
             <h2 className="text-sub-heading text-center mb-0 p-[10px]">
             {modelHeading}
           </h2>
          )}
        </div>
      </div>

      {/* end of car selection on mobile */}
      <div className="mt-[30px]">
        <Image
          // src={`${configuration.IMG_URL}${selectedColor?.image}`}
          src={
            !local
              ? selectedColor?.image? configuration.IMG_URL + selectedColor?.image : ""
              : selectedColor?.image
          }
          alt={selectedColor?.img_alt_text}
          width={310}
          height={200}
          objectFit="contain"
        />
      </div>
      <ul className="compareItem__colorChoices" id="colorChoices">
        {selected?.colors
          .sort(function (a, b) {
            return a?.order_index - b?.order_index;
          })
          .map((color, i) => {
            return (
              <>
                <li key={i} title={color.color_name}>
                  <input
                    defaultChecked={color.is_default}
                    type="radio"
                    id={color._id + id + i}
                    name={selected?.variant_name + id}
                    className="hidden"
                    checked={selectedColor?.color_code == color?.color_code}
                    onChange={() =>
                      setSelectedColor({
                        ...selected.colors[i],
                        id: Math.floor(Math.random() * 999999),
                      })
                    }
                  />
                  {/* additional information tool tip starts */}
                  {/* {
        (color?.additionalInformation || additionalInformationVariant || additionalInformationOfModel) && (color?.additionalInformation?.enable || additionalInformationVariant?.enable || additionalInformationOfModel?.enable) && <div className="homeSuzukiCard__priceInfo">
          <div className="tool-tip-img inline-flex items-center align-middle" data-tooltip-id={"colorInfo"+ i}>
            <Image
              src={`${configuration.IMG_STATIC_URL}assets/images/infoIcon.svg`}
              height="15"
              width="15"
            />
            <p className="homeSuzukiCard__priceInfo_title">
            <input
              defaultChecked={color.is_default}
              type="radio"
              id={color._id + id + i}
              name={selected?.variant_name + id}
              className="hidden"
              onChange={() =>
                setSelectedColor({
                  ...selected.colors[i],
                  id: Math.floor(Math.random() * 999999),
                })
              }
            />
            </p>
          </div>
          <Tooltip
            id={"colorInfo"+i}
            src={`${configuration.IMG_STATIC_URL}assets/images/Tool-tip/infoToolTip.svg`}
            variant="dark"
            place="right"
            className="shadow-lg max-w-[325px] rounded-[5px]"
          >
            <div className="tool-tip-wrap max-w-[325px]">
              {/* <p className="block mb-0 mb-1 text-[12px] text-inverted font-suzukiBold">
                This is a tooltip
              </p> */}
                  {/* {console.log("color description--->",color?.additionalInformation)}
              <p className="mb-0 text-[12px] text-inverted font-suzukiRegular">
                {color?.additionalInformation?.description?color?.additionalInformation?.description:additionalInformationVariant?.description?additionalInformationVariant?.description:additionalInformationOfModel?.description}
              </p>
            </div>
          </Tooltip>
        </div>
      } */}
                  {/* additional information tool tip ends */}
                  <label htmlFor={color._id + id + i}>
                    {color.hex_code2 ? (
                      <>
                        <span
                          className="rounded-l-full z-[-1]"
                          style={{ backgroundColor: `${color.hex_code}` }}
                        ></span>
                        <span
                          className="rounded-r-full  z-[-1]"
                          style={{ backgroundColor: `${color.hex_code2}` }}
                        ></span>
                      </>
                    ) : (
                      <span
                        className="rounded-full z-[-1]"
                        style={{ backgroundColor: `${color.hex_code}` }}
                      ></span>
                    )}
                  </label>
                </li>
              </>
            );
          })}
      </ul>

      <p className="compareItem_carVariant">
        {selectedColor?.color_name}
        {/* <span>{Constants.compare.INCLUDED}</span> */}
      </p>
      {/* additional information tool tip variants starts */}

      {/* additional information tool tip ends */}

      {!local && isPriceLoaded && (
  <>
    {cmpfirstPrice &&
    IsValidPrice(cmpfirstPrice) &&
    cmpfirstPrice > 0 &&
    variantCmpfirstPriceText ? (
      <div className=" flex flex-col items-center mt-[15px] relative">
        <div className="absolute top-[-20px]">
          <Tooltip />
        </div>
        <h6 className="compareItem__price">
          {formatCurrency(cmpfirstPrice)}
        </h6>
        <p>{variantCmpfirstPriceText}</p>
      </div>
    ) : null}

    {cmpsecondPrice &&
    IsValidPrice(cmpsecondPrice) &&
    cmpsecondPrice > 0 &&
    variantCmpsecondPriceText ? (
            <div className=" flex flex-col items-center mt-[15px]">
        <h6 className="compareItem__price">
          {formatCurrency(cmpsecondPrice)}
        </h6>
        <p>{variantCmpsecondPriceText}</p>
      </div>
    ) : null}

    {cmpthirdPrice &&
    IsValidPrice(cmpthirdPrice) &&
    cmpthirdPrice > 0 &&
    variantCmpthirdPriceText ? (
            <div className=" flex flex-col items-center mt-[15px]">
        <h6 className="compareItem__price">
          {formatCurrency(cmpthirdPrice)}
        </h6>
        <p>{variantCmpthirdPriceText}</p>
      </div>
    ) : null}
  </>
)}

{local && modelPrice &&  IsValidPrice(modelPrice) && typeof modelPrice !="undefined" && modelPrice !="undefined" &&  modelPrice>0 && isPriceLoaded ?  <h6 className="compareItem__price mt-[15px]">{modelPrice}</h6>:local &&  configuration?.COUNTRY_CODE=="VNM" && modelPrice &&  IsValidPrice(parseFloat(String(modelPrice).replace(/[^\d.]/g, ''))) && parseFloat(String(modelPrice).replace(/[^\d.]/g, ''))>0  ? <h6 className="compareItem__price mt-[15px]">{modelPrice}</h6>:""}
    
    </div>
  );
};

export default CompareItem;